import React, { useState } from "react";
import ctl from "@netlify/classnames-template-literals";

import { Text } from "components";

const Tabs = ({ data, light }) => {
  const [currentTab, setCurrentTab] = useState(0);

  const currentTabContent = data[currentTab];

  const tabNavigation = data.map((tab, index) => {
    const isCurrentTab = index === currentTab;
    return (
      <>
        <button
          onClick={() => setCurrentTab(index)}
          role="tab"
          className={`${navItemStyle} ${
            isCurrentTab ? "border-primary " : "border-transparent"
          }`}
          ariaSelected={isCurrentTab ? "true" : "false"}
          tabindex="-1"
        >
          <Text
            value={tab.title}
            variant="p18"
            weight="bold"
            color={isCurrentTab ? "secondary-100" : "secondary-800"}
          />
        </button>
      </>
    );
  });

  const tabsContent = data.map((tab, index) => {
    const isCurrentTab = index === currentTab;

    return (
      <>{isCurrentTab ? <div role="tabpanel">{tab.content}</div> : null}</>
    );
  });
  return (
    <>
      <nav className={navigationStyle} role="tablist">
        {tabNavigation}
      </nav>

      {tabsContent}
    </>
  );
};

const navigationStyle = ctl(`
border-secondary-100
border-b
overflow-x-auto
flex
`);

const navItemStyle = ctl(`
py-4
mr-8
shrink-0
border-b-4

`);
export { Tabs };
